var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "5l86b",
    width: 45,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAEAklEQVRoQ82ZW+hlUxzHP18khFIzLokXl8itxDC5hELKFHIL8UTx5M7DNG4pkxkeFMULyUSEByQPmJgwRimTcnlyybhlkEuir36nvc+ss+bsc/be6/zn/Nfb6azf7/dZv7X29/dbe4sZDNs7AecBlwAnA4cAuwD/AV8BG4FXgRck/VUaUqUObJ8PPAQc1sLXz8A9wKOSYkG9Rm9o2zsDjwDX94j8NnCxpFhE59ELugJ+Hriwc8RtBpuB0yX90tVHX+gHgDsagsUZfgf4CdgbOB44FhgX6xVJKxYc2vZJwHtjID4HbpL0Wg5h+3BgNXDBGMBLJcWutR6dM237DeDsLEJkdoWkXydFtn03cFc251NJR7UmbtiyRnvbhwJfZBO2AEe3eahsR5LWA6dlPpZJ+rAteKdM274ReDhzfoOkx9oGtH0u8Ho2f6Wk+9v66Ar9NHBV4jy0dmkXBbC9K7AV2D3x85ykyxcK+i3gjMT5l5LaFJURHtufAfFw1mO9pNTvRP6umf6okrDa6QZJp7bNUD3P9sfAcTsKuijYgkPbPhI4BzgQiHMY40pgSZKhb6MJ6prpFn7+AKJivjyuwdrueNgOqMcLS3SPdYw1+S46R0kb0n9HoG1H2f0AOGJWUWfgJwpW1IFval85dLSNq2YQaNYu1kq6tQk6qtIJs444A38bJUXPMxh5pmMr4ogMH3TgZuCpKCClUjVNPWzvA1xTXSpStq2S4r9RaNtLgR+yrKyTFIoxGAsNncR5BrgiY1lS9zfD1dg+BXg3m3idpCfmAH1tpWApznJJ748cD9uxLU9m0GdJitK9ozN9JvBmxnK1pOh9tp1p2/cBK7OJB0v6OoEOOVyWzOnUM7T1Y/ug6haf4twradCLp8fjWeCyZNbfwB6SnASL28ftyZzVku7MFjr1p+2Jfqq++09gt8TZ8PlKofNmaLOkY1KCqq2MHYl3G3HlWiXpn6mU2YQ2fmx/EkUlMd0k6cQ807ncRd0vuW13XcvIfNsvZXfKoewNMt0gd2sk3VYUucDY9oPAsApWrgayV0NPlbuC+L1MbTfKXg09Ve56RS4wst0oezX0VLkriN/LdJLs1dBT5a5X5AKjSbJXQ0+Vu4L4vU2bZK+GXlRylxSzsbKnxSh3CfR42WvT3fXe30LDRtlr090Vxu5t3ih7bbq73lELDRtlz/aik7vkTIdQbN/t2c7l7kdJ+xYmaWbmtuMKGFfBemwK9cjlLv68SFLIzVyH7egyX8wgfgvoYZOf/Plv9brr+zlS7xdfwKrvkSMYAR2vnvafI1zX0FsCeg1wS1fLOc5fG9B7Vlen9GozR6aJoeNN6vK699ir+uoUL0gOWITEcYTXxSdqSb//D0du2yS6q+BQAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5l86a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 45V0h45v45z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(\"#5l86a\")"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5l86b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIconWhite);
export default __webpack_public_path__ + "static/media/bag_icon_white.94390006adb4ede0aa9cb341b3ee7cc9.svg";
export { ForwardRef as ReactComponent };